import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
});

export class TilopayFetchAPI {
    //Function to refund a tilopay payment (the server tries a reversal first and a refund if it is rejected).
    //The credentials of the gateway stay on the server.
    static async refund(data, token) {
        const res = await server(`/tilopay/refund`, {
            method: "post",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }
}
